module.exports = __webpack_public_path__ + "static/media/34.e90d8e0e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/34.svg
// module id = 404
// module chunks = 14